'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/information-settings`).reply(200, {
    'success': true,
    'data': {
      'notify_merge_task': 1,
      'save_information': 100
    }
  })

  mockAxios.onPut(`/information-settings`).reply(201, {
    'success': true,
    'data': {}
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/informationSettingsRepositoryMock.js